// scrollTo fn
$.fn.scrollView = function ( getOffset ) {
	if ( getOffset == null ) {
		getOffset = 0;
	}
	return this.each(function () {
		$('html, body').animate({
			scrollTop: $(this).offset().top + getOffset
		}, 1000);
	});
}

window.documentReady(() => {
	// Mobile navigation toggling
	const mobileNavToggle = document.querySelectorAll('.toggle-mobile-nav')
	if (mobileNavToggle.length === 1) {
		mobileNavToggle[0].addEventListener('click', (e) => {
			e.preventDefault()
			const classOpened = 'mobile-nav-opened'
			const hasOpenedClass = window.hasClass(document.body, classOpened)

			if (hasOpenedClass) {
				window.removeClass(document.body, classOpened)
			} else {
				window.addClass(document.body, classOpened)
			}
		})
	}

	// Scroll links - scroll to anchor
	document.querySelectorAll('a[data-toggle="scroll"]').forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			let targetElement = document.getElementById(link.getAttribute('href').substr(1))
			window.scrollToElement(document.documentElement, targetElement.offsetTop);
		})
	})

	document.querySelectorAll('.orderby').forEach((select) => {
		// eslint-disable-next-line
		new SlimSelect({
			select,
			allowDeselect: true,
			deselectLabel: '<span>✖</span>'
		})
	})

	if ( $( '#billing_business_consumer_selector' ).length) {
		$('#billing_business_consumer_selector').select2({
			minimumResultsForSearch: -1
		});
	}

	$('[data-toggle="tooltip"]').tooltip({
		placement: 'bottom'
	})

	//hide filter on category page on small devices
	var actualWindowWidth = getWindowWidth();
	var objectToHide = $( '.sidebar-wrap' );
	var objectToClick = $( '#filterMob' );

	function getWindowWidth() {
		return $( window ).width()
	}

	if( actualWindowWidth < 768 ) {
		objectToHide.toggle( 'slow' );
	}

	$( window ).on( 'resize', function() {
		actualWindowWidth = getWindowWidth()
	})

	objectToClick.on( 'click', function( e ) {
		e.preventDefault();
		objectToHide.toggle( 'slow' );
	} )

	// slider for references
	let initReferencieSlider = () => {
		let $slider = $('#slider-referencie');
		let $carouselNav = $slider.next('.carousel-nav')

		$slider.slick({
			slidesToShow: 3,
			slidesToScroll: 3,
			appendArrows: $carouselNav,
			dots: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			],
			prevArrow: $carouselNav.find('.prev-slide'),
			nextArrow: $carouselNav.find('.next-slide')
		})
	}

	initReferencieSlider()

	/*var holder = $( '.widget .product-categories .children li' ).not( '.current-cat > ul > li' ).not( '.current-cat-parent > ul > li' ).not( 'current-cat' );
	jQuery.fx.off = true
	holder.slideToggle( 0, function() {
		$( '.product-categories' ).attr( 'style', 'display: block' );
		jQuery.fx.off = false
	} ); // hide all nested lists*/



	if ($('.wpcf7-form').length) {

		// Contact Form 7 radio buttons
		$('.wpcf7-radio').on('click', 'input', function () {
			$(this).closest('.wpcf7-radio').find('label').removeClass('checked').find('input').removeAttr('checked');
			$(this).parent('label').addClass('checked');
			$(this).prop('checked', true);
		});

		// Contact Form 7 checkbox
		$('.wpcf7-checkbox label').on('click', function () {
			var checkbox = $(this).find('input');
			if (checkbox.is(':checked')) {
				//console.log('attribute');
				checkbox.removeAttr('checked').removeClass('checked').prop('checked', false).parent('label').removeClass('checked');
			} else {
				//console.log('nema attribute');
				checkbox.attr('checked', 'checked').addClass('checked').prop('checked', true).parent('label').addClass('checked');
			}
		});

		//acceptance
		$('.wpcf7-acceptance label').on('click', function () {
			var checkbox = $(this).find('input');
			if (checkbox.is(':checked')) {
				//console.log('attribute');
				checkbox.removeAttr('checked').removeClass('checked').prop('checked', false).parent('label').removeClass('checked');
			} else {
				//console.log('nema attribute');
				checkbox.attr('checked', 'checked').addClass('checked').prop('checked', true).parent('label').addClass('checked');
			}
		});

	}

})

window.addEventListener('scroll', () => {
	let header = document.querySelectorAll('div.header')
	const startedOffset = 10
	const pageOffset = window.pageYOffset

	if(header.length !== 1) {
		return
	} else {
		header = header[0];
	}

	// ak header dosiahol hranicu alebo je POD nou, zapni class
	if (pageOffset >= startedOffset) {
		if (false === window.hasClass(header, 'header-scrolling')) {
			window.addClass(header, 'header-scrolling')
		}
	}

	// ak je header NAD hranicou, vypni class
	if (pageOffset < startedOffset) {
		if (true === window.hasClass(header, 'header-scrolling')) {
			window.removeClass(header, 'header-scrolling')
		}
	}
})

//copy productID and productUrl to form-modal, when price is 0 or empty
var zeroPriceModal = $( '#zeroPriceModal' );
//console.log( zeroPriceModal );
//if( zeroPriceModal.is( ':hidden' ).length ) {
	$( '.fire-form' ).on( 'click', function( e ) {
		var productID = $( this ).data( 'productid' );
		var productURL = $( this ).data( 'producturl' );
		var productName = $( this ).data( 'productname' );
		e.preventDefault();
		$( '#quoteprod' ).html( productName );
		$( 'input[name="product_id"]' ).val( productID );
		$( 'input[name="product_url"]' ).val( productURL );
		$( 'input[name="product_name"]' ).val( productName );
		zeroPriceModal.modal();
	} )
//}

